import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import {
    FileText,
    Heart,
} from "lucide-react"
import CustomTabs from "components/tabs/customTab";
import TicketFilter from "./TicketFilter";
import TicketCard from "./TicketCard";
import { tickets } from "./Tickets";
import NoTickets from "./NoTickets";
import GridCard from "./CategoryGridCard";
import {
    getTicketList,
} from "../../../../../redux/supportticket/supportticketState";
import {
    getHrCategoryList,
    getTicketStatusList
} from "../../../../../redux/optionlist/optionlistState";
import { Pagination } from "antd";

const SupportTabs = ({
    doSearch,
    getHrCategory,
    hrCategory,
    ticketStatus,
    getTicketStatus,
    recordList,
    filters = {},
    pagination,
    ticketType = 'hr',
}) => {

    const [activeTab, setActiveTab] = useState("tickets"); 
    
    const TabLabel = ({ icon: Icon, text }) => (
        <div className="flex items-center justify-center gap-2">
            <Icon className="text-gray-800 w-4 h-4" />
            <span className="text-sm font-medium">{text}</span>
        </div>
    );

    const tabOptions = [
        { label: <TabLabel icon={Heart} text={`My Tickets (${recordList?.length || 0})`} />, value: "tickets" },
        { label: <TabLabel icon={FileText} text="Resources" />, value: "resources" },
    ];

    const categoryOptions = hrCategory || [];

    const statusOptions = ticketStatus || [];

    const onSelectFilter = (field, value) => {
        
        const data = {
            ...(filters || {}),
            page: 1,
            paginate: pagination?.per_page || 10,
            ticketType: ticketType,
        };

        if (value && value !== "all" && value !== 0 && value !== "") {
            if (field === "search") {
                data.keyword = value; 
            } else {
                data[field] = value;
            }
        } else {
            if (field === "search") {
                delete data.keyword;
            } else {
                delete data[field];
            }
        }
        
        doSearch(data);
    };

    const handleSearchChange = ({ keyword }) => {
        onSelectFilter("search", keyword);
    };

    useEffect(() => {
        getHrCategory();
        getTicketStatus();
    }, [getHrCategory, getTicketStatus]);

    useEffect(() => {
        doSearch({
            paginate: pagination.per_page,
            ticketType: ticketType
        });
    }, [doSearch, pagination.per_page, ticketType]);

    return (
        <div className="flex flex-col gap-2 space-y-6">
            <CustomTabs
                tabs={tabOptions}
                activeTab={activeTab}
                onChange={setActiveTab}
            />

            <>
                {activeTab === "tickets" && (
                    <div className="flex-1 outline-none space-y-6">
                        <TicketFilter
                            searchQuery={filters?.search}
                            onSearchChange={handleSearchChange}
                            category={filters?.category_id || "all"}
                            onCategoryChange={(value) => onSelectFilter("category_id", value)}
                            status={filters?.status_id || "all"}
                            onStatusChange={(value) => onSelectFilter("status_id", value)}
                            categoryOptions={categoryOptions}
                            statusOptions={statusOptions}
                            filters={filters}
                            pagination={pagination}
                        />
                        <div className="space-y-4">
                            {recordList && recordList.length > 0 ? (
                                recordList.map((ticket) => (
                                    <TicketCard 
                                        key={ticket?.tic_id} 
                                        {...ticket} 
                                    />
                                ))
                            ) : (
                                <NoTickets />
                            )}
                            {pagination && pagination.total > 0 && (
                                <div className="flex justify-end py-4">
                                    <Pagination
                                        current={pagination.current_page}
                                        pageSize={pagination.per_page}
                                        total={pagination.total}
                                        showSizeChanger={false}
                                        onChange={(page) =>
                                            doSearch({
                                                ...filters,
                                                page,
                                                paginate: pagination.per_page,
                                                ticketType: ticketType,
                                            })
                                        }
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                )}

                {activeTab === "resources" && (
                    <GridCard tickets={tickets}/>
                )}
            </>
        </div>
    );
};

const mapStateToProps = (state) => ({
    recordList: state.ticket.ticketList?.items,
    pagination: state.ticket.ticketList?.pagination,
    filters: state.ticket.ticketList?.filters,
    hrCategory: state.optionlist.hrCategoryList?.items,
    ticketStatus: state.optionlist.ticketStatusList?.items,
});

const mapDispatchToProps = (dispatch) => ({
    doSearch: (filters) => dispatch(getTicketList(filters)),
    getHrCategory: (data) => dispatch(getHrCategoryList(data)),
    getTicketStatus: (data) => dispatch(getTicketStatusList(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SupportTabs);
